export enum InsuranceChargeCategory {
    RoomBoardingNursingExpenses = 1,
    IcuIccuCharges = 2,
    SurgeonConsultantFees = 3,
    AnaesthesiaOTCharges = 4,
    MedicinesDrugs = 5,
    DiagnosticLaboratoryCharges = 6,
    RadiologyImagingCharges = 7,
    PhysiotherapyCharges = 8,
    DayCareProcedureCharges = 9
}

export const InsuranceChargeCategoryLabels: Record<InsuranceChargeCategory, string> = {
    [InsuranceChargeCategory.RoomBoardingNursingExpenses]: "Room, Boarding & Nursing Expenses",
    [InsuranceChargeCategory.IcuIccuCharges]: "ICU / ICCU Charges",
    [InsuranceChargeCategory.SurgeonConsultantFees]: "Surgeon / Anaesthetist / Specialist / Consultant / Medical Practitioner Fees",
    [InsuranceChargeCategory.AnaesthesiaOTCharges]: "Anaesthesia, Blood, Oxygen, OT Charges, Surgical Appliances",
    [InsuranceChargeCategory.MedicinesDrugs]: "Medicines & Drugs",
    [InsuranceChargeCategory.DiagnosticLaboratoryCharges]: "Diagnostic / Laboratory Charges",
    [InsuranceChargeCategory.RadiologyImagingCharges]: "Radiology / Imaging Charges",
    [InsuranceChargeCategory.PhysiotherapyCharges]: "Physiotherapy Charges",
    [InsuranceChargeCategory.DayCareProcedureCharges]: "Day Care / Procedure Charges"
};